/**
 * Concurrent-dispatch dedupe for async thunks.
 *
 * Prevents the same request from being issued again while it is still running:
 * React StrictMode's dev double-invoke, rapid mount/unmount, or several
 * components fetching the same farm at once. It does NOT cache across settle —
 * once a request resolves its key is cleared, so a later revisit refetches.
 * No TTL, so no staleness risk; this only collapses genuinely concurrent work.
 *
 * Usage in a createAsyncThunk:
 *   async (arg) => {
 *     const key = `fields:${arg.farm_id}`;
 *     markInFlight(key);
 *     try { ...work... } finally { clearInFlight(key); }
 *   },
 *   { condition: (arg) => !isInFlight(`fields:${arg.farm_id}`) }
 */
const keys = new Set<string>();

export const isInFlight = (key: string): boolean => keys.has(key);
export const markInFlight = (key: string): void => {
  keys.add(key);
};
export const clearInFlight = (key: string): void => {
  keys.delete(key);
};
